module.exports = __webpack_public_path__ + "img/internal-audit.f4c12231.png";